module.exports = __webpack_public_path__ + "img/ctrl-u-stub-down-+i.0a407225.svg";